import React, { useEffect, useRef } from 'react';
import { Parser } from 'html-to-react';
import { Between, ButtonSmall, ButtonLink, Center, LabelBig, LabelSubTitle, Paragraph, Row, IconSmall } from 'meitav-uikit';

const PopUpMessage = props => {

  const p = new Parser();

  const handleClose = () => {
    if (props.handleClose) {
      props.handleClose();
    }
    window.popupClose();
  }
  const handleCick = () => {
    if (props.handleCick) {
      props.handleCick();
    }
    window.popupClose();
  }
  const handleLink = () => {
    if (props.handleLink) {
      props.handleLink();
    }

  }

  return (
    < >

{props.title &&   <LabelSubTitle align="center">{props.title}</LabelSubTitle>}
      {props.iconSrc && props?.description  
   &&   <Between>  <IconSmall src={props.iconSrc} />
        <Paragraph>{p.parse(props?.description)}</Paragraph>  </Between>}
        {!props.iconSrc && props?.description  && <Paragraph>{p.parse(props?.description)}</Paragraph>}


      {props.specialText && <LabelBig align="center" addClass='special'>{props.specialText}</LabelBig>}
      {props.closeLink && <ButtonLink text={props.btnCancelText} onClick={handleClose} />}
      {props.btnClickLink && <ButtonLink text={props.btnClickLink} onClick={handleLink} />}

      {props.btnClickText && !props.btnCancelText && !props.closeLink ?
        <Center>
          <ButtonSmall text={props.btnClickText} onClick={handleCick} />
        </Center>
        :
        <Between>
          {props.btnClickText && <ButtonSmall text={props.btnClickText} onClick={handleCick} />}
          {props.btnCancelText && !props.closeLink && <ButtonSmall text={props.btnCancelText} onClick={handleClose} />}
        </Between>
      }
    </>
  );
};

export default PopUpMessage;
